import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CheckedIcon } from '@spa/shared/svg';
import { Input, Label, Box } from './styles.js';
export * from './styles';

const Checkbox = ({ name, value, onChange, children, checked = false, label, icon, helperText }) => {
  const [internalChecked, setInternalChecked] = useState(checked);

  const handleChange = (...args) => {
    setInternalChecked(() => !internalChecked);

    onChange(...args);
  };

  useEffect(() => setInternalChecked(() => checked), [checked]);

  return (
    <div>
      <Input
        type="checkbox"
        id={`${name}-${value}`}
        name={name}
        value={value}
        checked={internalChecked}
        onChange={handleChange}
      />
      <Label htmlFor={`${name}-${value}`}>
        {icon ? (
          icon
        ) : (
          <Box>
            <CheckedIcon />
          </Box>
        )}
        <span className="label">
          {label}
          {helperText ? <p>{helperText}</p> : null}
        </span>
        {children}
      </Label>
    </div>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  icon: PropTypes.object,
  value: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.object,
  helperText: PropTypes.string
};

export default Checkbox;
